// extracted by mini-css-extract-plugin
export default {"tables_board":"style_tables_board__cSc1e","tables_list":"style_tables_list__dcIzK","table":"style_table__TAtmh","active":"style_active__N9xTK","header":"style_header__OV8g2"};